import React, { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import * as uuid from 'uuid';
import { getUA, browserName, isDesktop } from 'react-device-detect';

// material
import Button from "@material-ui/core/Button";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";

// icons
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { QuestionAnswer } from "@material-ui/icons";

// styles
import useFirstStyles from "../styles/firstStyles";
import useStyles from "../styles/index";

// context
import { useAuthDispatch } from "../contexts/AuthContext";

// api
import { checkTokenRequest } from "../api/auth";
import { sanaBaseUrl } from "../constants";


import UpImage from '../assets/img/up.png';
import DownImage from '../assets/img/down.png';
import LeftImage from '../assets/img/left.png';
import RightImage from '../assets/img/right.png';
import { _UUID } from '../config/constantApi';

const getTranslate = (direction: string) => {
  switch (direction) {
    case "up":
      return UpImage;
    case "down":
      return DownImage;
    case "left":
      return LeftImage;
    case "right":
      return RightImage;
    default:
      break;
  }
};
const FirstPage = (props: any) => {
  // uses
  const dispatch = useAuthDispatch();
  const history = useHistory();
  // page var
  const [openDialog, setOpenDialog] = useState(false);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  // style
  const firstClasses = useFirstStyles();
  const classes = useStyles();
  //

  useEffect(() => {
    localStorage.removeItem(_UUID);
  }, []);


  useEffect(() => {
    dispatch({ type: "CLEAR_STATE" });
    const query = new URLSearchParams(history.location.search);
    const token = query.get("token");
    const returnUrl = query.get("returnUrl");
    const requestNo = query.get("requestNo");


    localStorage.setItem('token', token as string);
    localStorage.setItem('returnUrl', returnUrl as string);
    localStorage.setItem('requestNo', requestNo as string);

    const deviceType = ` ${isDesktop ? 'desktop' : 'mobile'},${browserName},${getUA}`;


    if (token && returnUrl && requestNo) {
      checkToken(token, returnUrl, requestNo, deviceType);
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, history]);

  // methods

  const checkToken = async (
    token: string,
    returnUrl: string,
    requestNo: string,
    deviceType: string,

  ) => {
    try {
      const response = await checkTokenRequest(token, returnUrl, requestNo, deviceType);

      localStorage.setItem('uniqueId', response.data.uniqueId);

      setVerified(response.data.tokenValidity);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const startAuth = () => {
    localStorage.setItem(_UUID, uuid.v4());

    // dispatch({ type: "SET_TIMEOUT" });
    history.push("/signature");
  };

  return (
    <div className={firstClasses.root}>
      <Typography className={firstClasses.h1} variant="h1">
        احراز هویت برخط سامانه ثنا
      </Typography><br/>
      <Typography className={firstClasses.h2} variant="h2">
        با سرویس هوشمند<b style={{ fontWeight: 'bold' }}> ویدا</b> 
      </Typography>
      {loading && <CircularProgress />}
      {verified ? (
        <Button
          fullWidth
          className={firstClasses.actionButton}
          color="primary"
          variant="contained"
          size="large"
          onClick={startAuth}
        >
          شروع فرایند احراز هویت
        </Button>
      ) : (
        <Button
          color="primary"
          className={firstClasses.actionButton}
          variant="contained"
          size="large"
          fullWidth
          href={sanaBaseUrl}
          target="_blan k"
        >
          ورود به سامانه ثنا
        </Button>
      )}
      {verified && (
        <>
          <Typography>در طول فرآیند احراز هویت از دکمه های</Typography>
          <Typography>بازگشت و به روزرسانی مرورگر استفاده نکنید!</Typography>
          <br/>
          <Typography style={{ fontWeight: 'bold' }}> مرکز تماس  پشتیبانی قوه قضائیه:  57798000-021  یا  1470-021</Typography>

          
          {/* <Typography style={{ fontWeight: 'bold' }}>  مرکز تماس پشتیبانی ویدا: 66066142 -021</Typography>
  */}
        </>
      )}
      <div className={firstClasses.logosContainer}>
        <img className={firstClasses.ghImage} src="/gh.png" alt="selfie" />
        <div className={firstClasses.logoContainer}>
          <img className={firstClasses.logo} src="/logo.png" alt="selfie" />
          {/* <p className={firstClasses.vida}>ویدا</p> */}
        </div>
      </div>
      <Button
        startIcon={<QuestionAnswer />}
        color="primary"
        onClick={() => setOpenDialog(true)}
      >
        سوالات متداول
      </Button>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>سوالات متداول</DialogTitle>
        <DialogContent>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
                روش ثبت نام برخط در سامانه ثنا قوه قضائیه به چه صورت است؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.justifyText}>
                پس از ورود به سایت سامانه{" "}
                <a href={sanaBaseUrl} target="_blank" rel="noreferrer">
                  ثبت نام الکترونیک
                </a>{" "}
                قوه قضائیه (ثنا) و انتخاب ثبت نام برخط شخص حقیقی، کاربر ابتدا
                اطلاعات اولیه خود را وارد نموده و سپس کارگزار ویدا را به عنوان
                کارگزار رسمی قوه قضائیه برای احراز هویت برخط انتخاب می کند.
              </Typography>
            </AccordionDetails>
          </Accordion>
         
          <Accordion
            expanded={expanded === "panel5"}
            onChange={handleChange("panel5")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
              برای انجام فرایند احراز هویت آنلاین چه  <b style={{ color: 'red' }}>ملزوماتی </b> لازم است؟              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.justifyText}>
              سیستم شما باید دارای دوربین تصویربرداری باشد  در صورتی که سیستم شما فاقد دوربین است <b style={{ color: 'red' }}>بدون پرداخت هزینه</b>  و از طریق لینک زیر مجددا با دستگاه موبایل اقدام نمایید.
             

              <br/>

              <a href="https://sana.adliran.ir/" rel="noreferrer">
                            https://sana.adliran.ir
               </a>      
              
              </Typography>
              

            </AccordionDetails>
          </Accordion>
        
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
                 برای احراز هویت برخط در سامانه ثنا از چه دستگاهی استفاده کنیم؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.justifyText}>
              برای این کار می‌بایست از گوشی‌های هوشمند اندرویدی یا ios، کامپیوتر رومیزی و یا لپ‌تاپ‌های مجهز به وب‌کم استفاده شود.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
              با استفاده از کدام مرورگرها در سامانه ثنا ثبت‌نام و احراز هویت کنیم؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.justifyText}>
              ترجیحاً در سیستم‌عامل های اندروید، ویندوز و لینوکس، از مرورگر Google Chrome و در سیستم‌عامل iOS، از مرورگر Safari استفاده شود.              </Typography>
            </AccordionDetails>
          </Accordion>


          <Accordion
            expanded={expanded === "panel4"}
            onChange={handleChange("panel4")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
              در هنگام ضبط ویدئو سلفی و تصویر سلفی به چه نکاتی توجه کنیم؟              </Typography>
            </AccordionSummary>
            <AccordionDetails>
            <ul>
            <li>
              <Typography className={classes.justifyText}>
                .از دسترسی مرورگر خود به دوربین و میکروفن گوشی تلفن همراه یا وب کم کامپیوتر رومیزی، اطمینان حاصل کنید
           </Typography> </li>
           <li><Typography className={classes.justifyText}>
            .صدای میکروفن خود را بلند کنید      
     </Typography> </li>
           <li><Typography className={classes.justifyText}>            
         دوربین را به‌صورت مستقیم، مقابل چهره خود نگه ‌دارید  (از خم کردن سر خود بپرهیزید)
          </Typography></li>
          
          <li><Typography className={classes.justifyText}>
         نور محیط کافی بوده و چهره در سایه قرار نگیرد  (پشت سر، نور آفتاب یا نور چراغ قرار نداشته باشد )
          </Typography></li>
          

              <li><Typography className={classes.justifyText}>
               به هنگام تصویر برداری، از پوشش مناسب (پوشش عرف جامعه) برخوردار باشید.              </Typography> </li>

               <li>  <Typography className={classes.justifyText}>فرد دیگری در کادر نباشد.  </Typography> </li>
               <li><Typography className={classes.justifyText}>
              .در هنگام تصویربرداری یا فیلمبرداری، دست لزرش نداشته باشد 
                          </Typography> </li>
              </ul>
            </AccordionDetails>
          </Accordion>


          


          <Accordion
            expanded={expanded === "panel6"}
            onChange={handleChange("panel6")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
              اگر در هنگام احراز هویت با مشکل مواجه شدیم چه کنیم؟              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.justifyText}>
              بعد از گذشت 30 دقیقه از طریق لینک زیر وارد شوید و بدون پرداخت هزینه مجددا فرایند احراز هویت را از ابتدا طی کنید.      
              <br/>
              <a href="https://sana.adliran.ir/" rel="noreferrer">
             https://sana.adliran.ir
              </a>     
              
              </Typography>
              

            </AccordionDetails>
          </Accordion>


          <Accordion
            expanded={expanded === "panel7"}
            onChange={handleChange("panel7")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
                مقدار زمان ثبت نام برخط در سامانه ثنا قوه قضائیه و از طریق
                کارگزاری ویدا چقدر است؟
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.justifyText}>
                به دلیل آنکه فرایند احراز هویت برخط فرد از طریق کارگزاری ویدا به
                صورت تمام خودکار و از طریق به روز‌ترین الگوریتم های پیشرفته حوزه
                هوش مصنوعی انجام می شود، بر‌اساس سرعت اینترنت، مدت زمان صرف شده
                برای احراز هویت برخط چند ثانیه تا چند دقیقه است که بسیار زمان
                کمی نسبت به احراز هویت حضوری محسوب می شود.
              </Typography>
            </AccordionDetails>
          </Accordion>



        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            بستن
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withRouter(FirstPage);
